module.exports = __webpack_public_path__ + "static/img/honor.4081593.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/honor.jpg
// module id = Z0rg
// module chunks = 1